import { createContext } from 'react';

type themeState = {
  isDarkMode?: boolean;
  setTeamValue: Function;
  isDataChangeSchedule?: boolean;
  setDataChange: Function;
  isDataChangeKpiTrade?: boolean;
  setDataChangeKpiTrade: Function;
  isDataChangeKpiTeam?: boolean;
  setDataChangeKpiTeam: Function;
  isDataChangeKpiTradePerson?: boolean;
  setDataChangeKpiTradePerson: Function;
  isDataChangeKpiShift?: boolean;
  setDataChangeKpiShift: Function;
  isDataChangeShiftElement?: boolean;
  setDataChangeShiftElement: Function;
  isChartOpen?: boolean;
  toggleChart?: any;
  isDataChangeAssignment?: boolean;
  setDataChangeAssignment: Function;
  isDataChangeShiftTemplate?: boolean;
  setDataChangeShiftTemplate: Function;
  isDataChangeTrade?: boolean;
  setDataChangeTrade: Function;
  isDataChangeTeam?: boolean;
  setDataChangeTeam: Function;
  isChangeTabPane?: boolean;
  setChangeTabPane: Function;
  isChangeCurrentTab?: boolean;
  changeCurrentContainerTabIndex?: number;
  setChangeCurrentTab: Function;
  isChangeCurrentTabTask?: boolean;
  currentTabTaskIndex?: number;
  setChangeCurrentTabTask: Function;
  setChangeCurrentTabEvent: Function;
  isChangeCurrentTabEvent: Boolean;
  setLoadAllowChange: Function;
  isLoadAllowChange: Boolean;
  currentTabEventIndex: number;
  setChangeEventID: Function;
  isChangeEventID: Boolean;
  currentEventID: number;
  isDataChangeWorkbench?: boolean;
  setDataChangeWorkbench: Function;
  workbenchDateTimeValue: string;
  setChangeCurrentTabWorkbenchBottom: Function;
  currentTabWorkbenchBottomIndex: number;
  isChangeCurrentTabWorkbenchBottom: Boolean;
  isDataChangeWorkbenchBottomData?: boolean;
  setDataChangeWorkbenchBottomData: Function;
  workbenchValueBottom: string;
  isDataChangeForTemplateWBData?: boolean;
  setDataChangeForTemplateWBData: Function;
  ForTemplateWBValue: number;
  isChangeTabForTemplateWB?: boolean;
  setChangeTabForTemplateWB: Function;
  planId: number;
  setPlanId: Function;
  isDataChangeMaterials: boolean;
  setDataChangeMaterials: Function;
  isTabChangeMaterials: boolean;
  setTabChangeMaterials: Function;
  isMaterialAllowChange: boolean;
  setMaterialAllowChange: Function;
  isAttachmentsAllowChange: boolean;
  setAttachmentsAllowChange: Function;
  isWorkordersAllowChange: boolean;
  setWorkordersAllowChange: Function;
  isKanbanAllowChange: boolean;
  setKanbanAllowChange: Function;
  isOperationsAllowChange: boolean;
  setOperationsAllowChange: Function;
  isResourcesAllowChange: boolean;
  setResourcesAllowChange: Function;
  isHierarchyDone: boolean;
  setHierarchyDone: Function;
  timeZone: string;
  setTimezone: Function;
  schedulerFetchRequest: boolean,
  setSchedulerFetchRequest: Function;
  quickScheduleDateOnLoad: Date;
  setQuickScheduleDateOnLoad: Function;
  isClickedQuickLoad:boolean;
  setIsClickedQuickLoad:Function;
  expandStatus:boolean;
  setExpandStatus:Function;
};

export const ThemeContext = createContext<themeState>({
  expandStatus:false,
  setExpandStatus: (value: boolean) => {},
  isClickedQuickLoad: false,
  setIsClickedQuickLoad: (value: boolean) => {},
  quickScheduleDateOnLoad: new Date(),
  setQuickScheduleDateOnLoad: (value: Date) => {},
  schedulerFetchRequest: false,
  setSchedulerFetchRequest: (value: boolean) => {},
  isDarkMode: false,
  setTeamValue: (value: boolean) => {},
  isChartOpen: false,
  toggleChart: null,
  isDataChangeSchedule: false,
  setDataChange: () => {},
  setDataChangeKpiTeam: () => {},
  isDataChangeKpiTeam: false,
  isDataChangeKpiTrade: false,
  setDataChangeKpiTrade: () => {},
  isDataChangeKpiTradePerson: false,
  setDataChangeKpiTradePerson: () => {},
  setDataChangeKpiShift: () => {},
  isDataChangeKpiShift: false,
  isDataChangeShiftElement: false,
  setDataChangeShiftElement: () => {},
  isDataChangeAssignment: false,
  setDataChangeAssignment: () => {},
  isDataChangeShiftTemplate: false,
  setDataChangeShiftTemplate: () => {},
  setDataChangeTrade: () => {},
  isDataChangeTrade: false,
  setDataChangeTeam: () => {},
  isDataChangeTeam: false,
  isChangeTabPane: false,
  setChangeTabPane: () => {},
  isChangeCurrentTab: false,
  setChangeCurrentTab: () => {},
  isChangeCurrentTabTask: false,
  changeCurrentContainerTabIndex: -1,
  currentTabTaskIndex: -1,
  setChangeCurrentTabTask: () => {},
  currentTabEventIndex: -1,
  isChangeCurrentTabEvent: false,
  setChangeCurrentTabEvent: () => {},
  setChangeEventID: () => {},
  isChangeEventID: false,
  currentEventID: -1,
  isDataChangeWorkbench: false,
  setDataChangeWorkbench: () => {},
  workbenchDateTimeValue: '',
  isChangeCurrentTabWorkbenchBottom: false,
  currentTabWorkbenchBottomIndex: -1,
  setChangeCurrentTabWorkbenchBottom: () => {},
  isDataChangeWorkbenchBottomData: false,
  setDataChangeWorkbenchBottomData: () => {},
  workbenchValueBottom: '',
  ForTemplateWBValue: -1,
  setChangeTabForTemplateWB: () => {},
  setDataChangeForTemplateWBData: () => {},
  isChangeTabForTemplateWB: false,
  isDataChangeForTemplateWBData: false,
  planId: 0,
  setPlanId: () => {},
  isLoadAllowChange: false,
  setLoadAllowChange: () => {},
  isMaterialAllowChange: false,
  setMaterialAllowChange: () => {},
  isDataChangeMaterials: false,
  setDataChangeMaterials: () => {},
  isTabChangeMaterials: false,
  setTabChangeMaterials: () => {},
  isAttachmentsAllowChange: false,
  setAttachmentsAllowChange: () => {},
  isOperationsAllowChange: false,
  setOperationsAllowChange: () => {},
  isWorkordersAllowChange: false,
  setKanbanAllowChange: () => {},
  isKanbanAllowChange: false,
  setWorkordersAllowChange: () => {},
  isResourcesAllowChange: false,
  setResourcesAllowChange: () => {},
  isHierarchyDone: false,
  setHierarchyDone: () => {},
  setTimezone: () => {},
  timeZone: '',
});
